import { useQuery  } from "react-query";
import { UIViewEnum } from "../../common/enums/UIViewEnum";
import BreadCrumbUtils, { IBreadCrumbData } from "../../components/bread-crumb/BreadCrumbUtils";
import { RouteContextType } from "../../hooks/use-route-context/UseRouteContext";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";


export type UseBreadcrumbQueryParameters = {
    customerID: number,
    viewID: UIViewEnum,
    routeContext: RouteContextType,
    offlineDataLoaded: boolean,
    offline: boolean
} & BaseUseQueryParameters<IBreadCrumbData>

export function useBreadcrumb(
    params: UseBreadcrumbQueryParameters
) {
    return useQuery<IBreadCrumbData | undefined, RestError>(
        keys.data(params.customerID,
            params.viewID,
            params.routeContext,
            params.offlineDataLoaded,            
            params.offline
            ),
        ({ signal }) => {
            if (params.customerID) {
                return BreadCrumbUtils.getData(params.customerID,
                    params.viewID,
                    params.routeContext,
                    params.offline,
                    params.offlineDataLoaded,
                    signal
                );
            }
        },
        {
            enabled: params.enabled,
            onError: params.onError,
            onSuccess: params.onSuccess,
            refetchInterval: params.refreshSeconds ? params.refreshSeconds  * 1000 : false,
            //keepPreviousData: true
            //staleTime: 0
        }
    );
}

